import React from 'react'
import { Helmet } from "react-helmet"
import { connect } from 'react-redux'
import Chart from "react-apexcharts"
import MainDashboardPagination from '../../../Pagination/MainDashboardPagination'
import { useEffect } from 'react'
const MonthDashboard = (props) => {
    const FormData = props.kpiData
    const currencyFormatter = props.currencyFormatter
    const numberFormatter = props.numberFormatter
    const CostProfitData = props.costProfitKPIData
    const SalesTrendingData = props.trendingData
    const JHBData = props.jhbData
    const CPTData = props.cptData
    const ProductData = props.productData
    const PageSize = props.pageSize
    const TotalProducts = props.TotalProducts
    var Month = props.month
    var MonthYear = props.monthYear
    const LoadMonthProductSalesList = props.loadMonthProductSalesList
    const Sortby = props.Sortby
    const SortDirection = props.SortDirection
    const onSortChange = props.onSortChange
    const onPageSizeChange = props.onPageSizeChange
    const onSortDirectionChange = props.onSortDirectionChange
    const apexChartSeries = (seriesName, seriesData, seriesName1, seriesData1) =>
    (
        [
            {
                name: seriesName,
                data: seriesData,
                type: 'line'
            },
            {
                name: seriesName1,
                data: seriesData1,
                type: 'column'
            }
        ]
    )
    const apexChartDualOptions = (chartId, xaxis, seriesA, seriesB) =>
    (
        {
            chart: {
                id: chartId,
                width: "100%",
                height: '500px',
                type: 'line',
                dropShadow: {
                    enabled: true,
                    color: '#000',
                    top: 18,
                    left: 7,
                    blur: 10,
                    opacity: 0.1
                },
                toolbar: {
                    show: true
                }
            },
            dataLabels: {
                enabled: true,
            },
            stroke: {
                curve: 'smooth'
            },
            markers: {
                size: 1
            },
            xaxis: {
                categories: xaxis
            },
            yaxis: [
                {
                    title: {
                        text: seriesA
                    },
                },
                {
                    opposite: true,
                    title: {
                        text: seriesB
                    }
                }
            ],
            colors: ['#1B2850', '#FF9F43',],
            stroke: {
                curve: 'smooth'
            },
            dataLabels: {
                enabled: false,
                style: {
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: 'black'
                },
                background: {
                    enabled: true,
                    foreColor: 'black',
                    borderRadius: 2,
                    padding: 4,
                    opacity: 0.9,
                    borderWidth: 1,
                    borderColor: '#fff',
                },
            },
            plotOptions: {
                pie: {
                    legend: {
                        position: 'bottom'
                    }
                }
            },
            grid: {
                show: false
            }

        }
    )
    return (
        <>
            <Helmet>
                <link rel="stylesheet" href="../assets/css/style.css" />
                <script src="../assets/js/script.js" />
                <script src="../assets/plugins/apexchart/chart-data.js" />
            </Helmet>
            <div>
                <div className="row">
                    <div className="col-lg-3 col-sm-6 col-6">
                        <div className="dash-widget">
                            <div className="dash-widgetimg">
                                <span><img src="assets/img/icons/dash1.svg" alt="img" /></span>
                            </div>
                            <div className="dash-widgetcontent">
                                { FormData?.revenue || FormData?.revenue >= 0 ? (
                                    <h5><span data-count={ Number(FormData['revenue']) }>{ currencyFormatter.format(FormData['revenue']) }</span> (<span data-count={ Number(numberFormatter.format(FormData['revenue_change'])) }>{ numberFormatter.format(Math.round(FormData['revenue_change'])) }%</span>)</h5>
                                ) :
                                    <h5>
                                        <span className="skeleton-loader"></span>
                                    </h5>
                                }
                                <h6>Total Revenue</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-6">
                        <div className="dash-widget dash1">
                            <div className="dash-widgetimg">
                                <span><img src="assets/img/icons/dash2.svg" alt="img" /></span>
                            </div>
                            <div className="dash-widgetcontent">
                                { FormData?.revenue || FormData?.revenue >= 0 ? (
                                    <h5><span data-count={ Number(FormData['net_revenue']) }>{ currencyFormatter.format(FormData['net_revenue']) }</span> (<span data-count={ Number(numberFormatter.format(FormData['net_revenue_change'])) }>{ numberFormatter.format(Math.round(FormData['net_revenue_change'])) }%</span>)</h5>
                                ) :
                                    <h5>
                                        <span className="skeleton-loader"></span>
                                    </h5>
                                }
                                <h6>Total Net Revenue</h6>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-6">
                        <div className="dash-widget dash2">
                            <div className="dash-widgetimg">
                                <span><img src="assets/img/icons/dash3.svg" alt="img" /></span>
                            </div>
                            <div className="dash-widgetcontent">
                                { FormData?.revenue || FormData?.revenue >= 0 ? (
                                    <h5><span data-count={ Number(FormData['tax']) }>{ currencyFormatter.format(FormData['tax']) }</span> (<span data-count={ Number(numberFormatter.format(Number(FormData['tax']) / Number(FormData['revenue']) * 100)) }>{ numberFormatter.format(Math.round(Number(FormData['tax'] / Number(FormData['revenue']) * 100))) }%</span>)</h5>
                                ) :
                                    <h5>
                                        <span className="skeleton-loader"></span>
                                    </h5>
                                }
                                <h6>Total Tax</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-6">
                        <div className="dash-widget dash3">
                            <div className="dash-widgetimg">
                                <span><img src="assets/img/icons/dash4.svg" alt="img" /></span>
                            </div>
                            <div className="dash-widgetcontent">
                                { FormData?.revenue || FormData?.revenue >= 0 ? (
                                    <h5><span>{ currencyFormatter.format(FormData['fee']) }</span> (<span>{ numberFormatter.format(Math.round(Number(FormData['fee']) / Number(FormData['revenue']) * 100)) }%</span>)</h5>
                                ) :
                                    <h5>
                                        <span className="skeleton-loader"></span>
                                    </h5>
                                }
                                <h6>Total Fee</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-6 d-flex">
                        <div className="dash-count">
                            <div className="dash-counts">
                                { FormData?.revenue || FormData?.revenue >= 0 ? (
                                    <h4>{ numberFormatter.format(FormData['quantity']) }</h4>
                                ) :
                                    <h5>
                                        <span className="skeleton-loader"></span>
                                    </h5>
                                }
                                <h5>Total Units</h5>
                            </div>
                            <div className="dash-imgs">
                                <i data-feather="user"></i>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-6 d-flex">
                        <div className="dash-count das1">
                            <div className="dash-counts">
                                { FormData?.revenue || FormData?.revenue >= 0 ? (
                                    <h4>{ numberFormatter.format(FormData['cnr_quantity']) }</h4>
                                ) :
                                    <h5>
                                        <span className="skeleton-loader"></span>
                                    </h5>
                                }
                                <h5>Total CnR Units</h5>
                            </div>
                            <div className="dash-imgs">
                                <i data-feather="user-check"></i>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-6 d-flex">
                        <div className="dash-count das2">
                            <div className="dash-counts">
                                { FormData?.revenue || FormData?.revenue >= 0 ? (
                                    <h4>{ currencyFormatter.format(FormData['cnr_revenue']) }</h4>
                                ) :
                                    <h5>
                                        <span className="skeleton-loader"></span>
                                    </h5>
                                }
                                <h5>Total CnR Revenue</h5>
                            </div>
                            <div className="dash-imgs">
                                <i data-feather="file-text"></i>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-6 d-flex">
                        <div className="dash-count das3">
                            <div className="dash-counts">
                                { FormData?.revenue || FormData?.revenue >= 0 ? (
                                    <h4>{ currencyFormatter.format(CostProfitData['total_cost'] ? CostProfitData['total_cost'] : 0) }</h4>
                                ) :
                                    <h5>
                                        <span className="skeleton-loader"></span>
                                    </h5>
                                }
                                <h5>Total Cost</h5>
                            </div>
                            <div className="dash-imgs">
                                <i data-feather="file"></i>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Button trigger modal --> */ }

                <div className="row">
                    <div className="col-lg-12 col-sm-12 col-12 d-flex">
                        <div className="card flex-fill">
                            <div className="card-header pb-0 d-flex justify-content-between align-items-center">
                                <h5 className="card-title mb-0">Sales</h5>
                                {/* <div className="graph-sets">
									<ul>
										<li>
											<span>Revenue</span>
										</li>
										<li>
											<span>Quantity</span>
										</li>
									</ul>
									<div className="dropdown">
										<button className="btn btn-white btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
											2022 <img src="assets/img/icons/dropdown.svg" alt="img" className="ms-2"/>
										</button>
										<ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
											<li>
												<a href="#" className="dropdown-item">2022</a>
											</li>
											<li>
												<a href="#" className="dropdown-item">2021</a>
											</li>
											<li>
												<a href="#" className="dropdown-item">2020</a>
											</li>												
										</ul>
									</div>
								</div> */}

                            </div>
                            <div className="card-body">
                                {/* <div id="sales_charts"></div> */ }
                                <Chart
                                    options={ apexChartDualOptions('sales-trending-data', [SalesTrendingData].map(x => x.map(a => (a[0]))).flat(2), 'Sales', 'Quantity') }
                                    // options={apexChartOptions('sales-trending-data',xaxis)}
                                    series={ apexChartSeries('Revenue', [SalesTrendingData].map(x => x.map(a => (a[1]))).flat(2), "Quantity", [SalesTrendingData].map(x => x.map(a => (a[2]))).flat(2)) }
                                    type="line"
                                    width="100%"
                                    height="300px"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-0">
                    <div className="card-body">
                        <div className="card-header pb-0 d-flex justify-content-between align-items-center">
                            <h4 className="card-title">Products</h4>
                            <div className="graph-sets">

                                <div className="dropdown mx-1">
                                    <button className="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        Page Size
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><a className={ PageSize === "10" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onPageSizeChange(e, "10") } } href="#">10</a></li>
                                        <li><a className={ PageSize === "20" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onPageSizeChange(e, "20") } } href="#">20</a></li>
                                        <li><a className={ PageSize === "50" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onPageSizeChange(e, "50") } } href="#">50</a></li>
                                        <li><a className={ PageSize === "100" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onPageSizeChange(e, "100") } } href="#">100</a></li>
                                    </ul>
                                </div>
                                <div className="dropdown">
                                    <button className="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        Sort by
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li><a className={ Sortby === "units" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onSortChange(e, "units") } } href="#">Units</a></li>
                                        <li><a className={ Sortby === "revenue" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onSortChange(e, "revenue") } } href="#">Sales</a></li>
                                        <li><a className={ Sortby === "cost" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onSortChange(e, "cost") } } href="#">Cost</a></li>
                                        <li><a className={ Sortby === "profit" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onSortChange(e, "profit") } } href="#">Profit</a></li>
                                    </ul>
                                </div>
                                <div className='py-1'>
                                    <button
                                        onClick={ (e) => { onSortDirectionChange(e, "up") } }
                                        className={
                                            SortDirection === "up" ?
                                                'btn btn-primary mx-1 my-1'
                                                :
                                                'btn btn-outline-primary mx-1'
                                        }
                                    >
                                        <i class="fa-solid fa-arrow-up-wide-short"></i>
                                    </button>
                                </div>
                                <div className='py-1'>
                                    <button
                                        onClick={ (e) => { onSortDirectionChange(e, "down") } }
                                        className={
                                            SortDirection === "down" ?
                                                'btn btn-primary mx-1'
                                                :
                                                'btn btn-outline-primary mx-1 my-1'
                                        }
                                    >
                                        <i class="fa-solid fa-arrow-down-wide-short"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive dataview">
                            <table className="table datatable ">
                                <thead>
                                    <tr>
                                        <th>Product Name</th>
                                        <th>Units</th>
                                        <th>Total Revenue</th>
                                        <th>Cost</th>
                                        <th>Profit</th>
                                        <th>PpS</th>
                                        <th>PpC</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        ProductData.length > 0 ?
                                            ProductData.map(
                                                (key, i) => {
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td className="productimgname">
                                                                    <a className="product-img" >
                                                                        <img src={ key.image_url } alt="product" />
                                                                    </a>
                                                                    <a href="#">{ key.product_title } ({ key.sku })</a>
                                                                </td>
                                                                {/* <td>
                                                                    {key.stock_at_takealot_total ? Number(key.stock_at_takealot_total)> 10 ?
                                                                    <>
                                                                        <span className="">
                                                                            {key.stock_at_takealot_total}
                                                                        </span>
                                                                    </>
                                                                    
                                                                    : 
                                                                    <span className="">
                                                                            {key.stock_at_takealot_total}
                                                                    </span> : <></>
                                                                    }
                                                                </td> */}

                                                                <td>
                                                                    <span>
                                                                        { numberFormatter.format(key.units) } Units
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        { currencyFormatter.format(key.sales) }
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        { key.cost ? currencyFormatter.format(key.cost) : currencyFormatter.format(0) }
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        { currencyFormatter.format(key.sales - key.cost) }
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        {
                                                                            key.sales ?
                                                                                Number(Math.round(Number((key.sales - key.cost) / key.sales) * 100), 2) < 5 ?
                                                                                    <>
                                                                                        <span className="">
                                                                                            { numberFormatter.format(Math.round(Number((key.sales - key.cost) / key.sales) * 100), 2) }%
                                                                                        </span>
                                                                                    </>
                                                                                    : Number(Math.round(Number((key.sales - key.cost) / key.sales) * 100), 2) > 5 && Number(Math.round(Number((key.sales - key.cost) / key.sales) * 100), 2) < 10 ?
                                                                                        <>
                                                                                            <span className="">
                                                                                                { numberFormatter.format(Math.round(Number((key.sales - key.cost) / key.sales) * 100), 2) }%
                                                                                            </span>
                                                                                        </>
                                                                                        : Number(Math.round(Number((key.sales - key.cost) / key.sales) * 100), 2) > 10 && Number(Math.round(Number((key.sales - key.cost) / key.sales) * 100), 2) < 20 ?
                                                                                            <>
                                                                                                <span className="">
                                                                                                    { numberFormatter.format(Math.round(Number((key.sales - key.cost) / key.sales) * 100), 2) }%
                                                                                                </span>
                                                                                            </>
                                                                                            : Number(Math.round(Number((key.sales - key.cost) / key.sales) * 100), 2) > 20 ?
                                                                                                <>
                                                                                                    <span className="">
                                                                                                        { numberFormatter.format(Math.round(Number((key.sales - key.cost) / key.sales) * 100), 2) }%
                                                                                                    </span>
                                                                                                </>
                                                                                                :
                                                                                                <>
                                                                                                    <span className="">
                                                                                                        { numberFormatter.format(0) }%
                                                                                                    </span>
                                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <span className="">
                                                                                        { numberFormatter.format(100) }%
                                                                                    </span>
                                                                                </>
                                                                        }
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        {
                                                                            key.sales ?
                                                                                key.cost == 0 ?
                                                                                    <span className="">
                                                                                        { numberFormatter.format(0) }%
                                                                                    </span>
                                                                                    :
                                                                                    Number(Math.round(Number((key.sales - key.cost) / key.cost) * 100), 2) < 5 ?
                                                                                        <>
                                                                                            <span className="">
                                                                                                { numberFormatter.format(Math.round(Number((key.sales - key.cost) / key.cost) * 100), 2) }%
                                                                                            </span>
                                                                                        </>
                                                                                        : Number(Math.round(Number((key.sales - key.cost) / key.cost) * 100), 2) > 5 && Number(Math.round(Number((key.sales - key.cost) / key.cost) * 100), 2) < 10 ?
                                                                                            <>
                                                                                                <span className="">
                                                                                                    { numberFormatter.format(Math.round(Number((key.sales - key.cost) / key.cost) * 100), 2) }%
                                                                                                </span>
                                                                                            </>
                                                                                            : Number(Math.round(Number((key.sales - key.cost) / key.cost) * 100), 2) > 10 && Number(Math.round(Number((key.sales - key.cost) / key.cost) * 100), 2) < 20 ?
                                                                                                <>
                                                                                                    <span className="">
                                                                                                        { numberFormatter.format(Math.round(Number((key.sales - key.cost) / key.cost) * 100), 2) }%
                                                                                                    </span>
                                                                                                </>
                                                                                                : Number(Math.round(Number((key.sales - key.cost) / key.cost) * 100), 2) > 20 ?
                                                                                                    <>
                                                                                                        <span className="">
                                                                                                            { numberFormatter.format(Math.round(Number((key.sales - key.cost) / key.cost) * 100), 2) }%
                                                                                                        </span>
                                                                                                    </>
                                                                                                    :
                                                                                                    <>
                                                                                                        <span className="">
                                                                                                            { numberFormatter.format(0) }%
                                                                                                        </span>
                                                                                                    </>
                                                                                :

                                                                                <>
                                                                                    <span className="">
                                                                                        { numberFormatter.format(100) }%
                                                                                    </span>
                                                                                </>
                                                                        }
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )
                                                }
                                            )
                                            :

                                            Array.from({ length: PageSize }).map((_, index) => (
                                                <tr key={ index }>
                                                    <td className="productimgname">
                                                        <h5>
                                                            <span className="skeleton-loader"></span>
                                                        </h5>
                                                    </td>
                                                    <td>
                                                        <h5>
                                                            <span className="skeleton-loader"></span>
                                                        </h5>
                                                    </td>
                                                    <td>
                                                        <h5>
                                                            <span className="skeleton-loader"></span>
                                                        </h5>
                                                    </td>
                                                    <td>
                                                        <h5>
                                                            <span className="skeleton-loader"></span>
                                                        </h5>
                                                    </td>
                                                    <td>
                                                        <h5>
                                                            <span className="skeleton-loader"></span>
                                                        </h5>
                                                    </td>
                                                    <td>
                                                        <h5>
                                                            <span className="skeleton-loader"></span>
                                                        </h5>
                                                    </td>
                                                </tr>
                                            ))
                                    }

                                </tbody>
                            </table>
                            <br />
                            <div className='pagination justify-content-center'>
                                {
                                    TotalProducts > 0 ?
                                        <MainDashboardPagination totalRecords={ TotalProducts } pageLimit={ Number(PageSize) } sortBy={ Sortby } sortDirection={ SortDirection } paginationDate={ MonthYear + "-" + Month } onPageChanged={ LoadMonthProductSalesList } />
                                        : <></>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => ({
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user,
})

export default connect(mapStateToProps)(MonthDashboard)